export default (impression) => ({
	id: impression.id,
	name: impression.name,
	variant: impression.variant,
	category: impression.category.string,
	price: impression.price.street.unformatted,
	position: impression.position,
	list: impression.list // Impression only
});
